import { motion } from "motion/react";

import classes from "./PatternsTypingIndicator.module.css";

export interface PatternsTypingIndicatorProps extends Omit<BoxProps, "style"> {
  from: "them" | "us";
}

const MotionGroup = motion.create(Group);

const PatternsTypingIndicator: FC<PatternsTypingIndicatorProps> = ({
  className,
  from,
  ...otherProps
}) => (
  <MotionGroup
    className={cn("PatternsTypingIndicator-root", classes.root, className)}
    gap={4}
    initial={{ opacity: 0, y: 10 }}
    animate={{
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 200,
        mass: 0.2,
        damping: 20,
      },
    }}
    exit={{ opacity: 0 }}
    mod={{ from }}
    {...otherProps}
  >
    {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      [...new Array(3)].map((_, i) => (
        <Box
          key={i}
          className={cn("PatternsTypingIndicator-dot", classes.dot)}
          style={{ animationDelay: `${(i + 1) / 3}s` }}
        />
      ))
    }
  </MotionGroup>
);

export default PatternsTypingIndicator;
